module.exports = __webpack_public_path__ + "fewww/img/2@2x.16726a98.png";